import { useMemo } from 'react';

import { useShowingMode as useShowingModeDefault } from 'js/components/main/CookiesRegulationMessage/hooks/useShowingMode';

export const useShowingMode = () => {
    const showingMode = useShowingModeDefault();

    return useMemo(() => {
        if (window.callPhantom) {
            return 'hidden';
        }

        return showingMode;
    }, [showingMode]);
};
